import Work1 from "../../assets/kunmiithe grapher.png";
import Work2 from "../../assets/cakeworlbc.jpg";
import Work3 from "../../assets/bernard shoes.png";
import Work4 from "../../assets/cakes world.png";
import Work5 from "../../assets/lolaniyibc.jpg";
import Work6 from "../../assets/minimal.png";
import Work7 from "../../assets/lolaniyi ventures.png";
import Work8 from "../../assets/lolaniyi venturesss.png";
import Work9 from "../../assets/otf.jpg";
import Work10 from "../../assets/rapupbc.jpg";
import Work11 from "../../assets/mujeeb stores.png";


export const projectsData = [
    {
        id: 1,
        image: Work1,
        title: "Web design",
        category: "web",
        link: "https://kunmiithegrapher.vercel.app",
    },
    {
        id: 2,
        image: Work6,
        title: "Brand design",
        category: "design",
    },
    {
        id: 3,
        image: Work2,
        title: "Brand design",
        category: "design",
    },
    {
        id: 4,
        image: Work7,
        title: "Web design",
        category: "web",
        link: "https://lolaniyiventures.netlify.app",
    },
    {
        id: 5,
        image: Work3,
        title: "Web design",
        category: "web",
        link: "https://bernardshoes.netlify.app",
    },
    {
        id: 6,
        image: Work8,
        title: "Web design",
        category: "web",
        link: "https://lolaniyiventures.vercel.app",
    },
    {
        id: 7,
        image: Work4,
        title: "Web design",
        category: "web",
        link: "https://cakeworlds.netlify.app",
    },
    {
        id: 8,
        image: Work9,
        title: "Brand design",
        category: "design",
    },
    {
        id: 9,
        image: Work5,
        title: "Brand design",
        category: "design",
    },
    {
        id: 10,
        image: Work10,
        title: "Brand design",
        category: "design",
    },
    {
        id: 11,
        image: Work11,
        title: "Web design",
        category: "web",
        link: "https://mujeebstores.netlify.app",
    },
    
];

export const projectsNav =[
    {
        name: "all",
    },
    {
        name: "web",
    },
    {
        name: "design",
    },
];